// extracted by mini-css-extract-plugin
export default {"dotIndicator":"b96mtqQEFGjR1jk6cqcQ"};